function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import classNames from 'classnames';
import Divider from '../../divider/Divider';
import ImageContainer from './ImageContainer';
import PrimaryContent from './PrimaryContent';
import SubContent from './SubContent';
import EventCardActions from './EventCardActions';
import ExtraContent from './ExtraContent';
import { LIST_TYPE, EVENT_CARD_PROPTYPES, MINI_STYLE, IMAGE_STYLE_FIXED } from './constants';

var ExtraContentContainer = function ExtraContentContainer(_ref) {
  var imageStyle = _ref.imageStyle,
      style = _ref.style,
      extraContent = _ref.extraContent;
  var component = null;

  if (imageStyle === IMAGE_STYLE_FIXED && style !== MINI_STYLE) {
    component = React.createElement("div", {
      className: "eds-show-up-sm"
    }, React.createElement(ExtraContent, {
      extraContent: extraContent
    }));
  }

  return component;
};

var DividerComponent = function DividerComponent(_ref2) {
  var shouldShowDivider = _ref2.shouldShowDivider;
  var component = null;

  if (shouldShowDivider) {
    component = React.createElement("div", {
      className: "eds-event-card-content__divisor eds-l-pad-vert-4"
    }, React.createElement(Divider, {
      color: "ui-orange"
    }));
  }

  return component;
};

var ListEventCardContentContainer = function ListEventCardContentContainer(_ref3) {
  var extraContent = _ref3.extraContent,
      title = _ref3.title,
      subtitle = _ref3.subtitle,
      onClick = _ref3.onClick,
      linkUrl = _ref3.linkUrl,
      linkAlt = _ref3.linkAlt,
      style = _ref3.style,
      shouldShowDivider = _ref3.shouldShowDivider,
      subContentOne = _ref3.subContentOne,
      subContentTwo = _ref3.subContentTwo,
      subContentThree = _ref3.subContentThree,
      subContentFour = _ref3.subContentFour,
      primaryIconType = _ref3.primaryIconType,
      primaryIconStyle = _ref3.primaryIconStyle,
      primaryIconTitle = _ref3.primaryIconTitle,
      primaryIconOnClick = _ref3.primaryIconOnClick,
      primaryIconDropdown = _ref3.primaryIconDropdown,
      secondaryIconType = _ref3.secondaryIconType,
      secondaryIconStyle = _ref3.secondaryIconStyle,
      secondaryIconTitle = _ref3.secondaryIconTitle,
      secondaryIconOnClick = _ref3.secondaryIconOnClick,
      shouldShowIcons = _ref3.shouldShowIcons,
      isConsumer = _ref3.isConsumer,
      isTargetBlank = _ref3.isTargetBlank,
      isNoFollow = _ref3.isNoFollow,
      useSmallPadding = _ref3.useSmallPadding;
  return React.createElement("div", {
    className: classNames('eds-event-card-content__content-container', {
      'eds-event-card-content__content-container--small-padding': useSmallPadding
    }, 'eds-l-pad-right-2')
  }, React.createElement("div", {
    className: "eds-event-card-content__content"
  }, React.createElement(ExtraContent, {
    content: extraContent
  }), React.createElement("div", {
    className: "eds-event-card-content__content__principal"
  }, React.createElement(PrimaryContent, {
    title: title,
    subtitle: subtitle,
    onClick: onClick,
    linkUrl: linkUrl,
    linkAlt: linkAlt,
    isConsumer: isConsumer,
    isTargetBlank: isTargetBlank,
    isNoFollow: isNoFollow,
    style: style,
    type: isConsumer ? LIST_TYPE : null
  }), React.createElement(DividerComponent, {
    shouldShowDivider: shouldShowDivider
  }), React.createElement(SubContent, {
    subContentOne: subContentOne,
    subContentTwo: subContentTwo,
    subContentThree: subContentThree,
    subContentFour: subContentFour,
    hasTwoActionButtons: secondaryIconType,
    isConsumer: isConsumer
  }))), React.createElement(EventCardActions, {
    primaryIconType: primaryIconType,
    primaryIconStyle: primaryIconStyle,
    primaryIconTitle: primaryIconTitle,
    primaryIconOnClick: primaryIconOnClick,
    primaryIconDropdown: primaryIconDropdown,
    secondaryIconType: secondaryIconType,
    secondaryIconStyle: secondaryIconStyle,
    secondaryIconTitle: secondaryIconTitle,
    secondaryIconOnClick: secondaryIconOnClick,
    shouldShowIcons: shouldShowIcons,
    isConsumer: isConsumer,
    isListCard: true
  }));
};

var ListEventCardContent =
/*#__PURE__*/
function (_Component) {
  _inherits(ListEventCardContent, _Component);

  function ListEventCardContent() {
    _classCallCheck(this, ListEventCardContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListEventCardContent).apply(this, arguments));
  }

  _createClass(ListEventCardContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          imageStyle = _this$props.imageStyle,
          imageUrl = _this$props.imageUrl,
          isLazyImage = _this$props.isLazyImage,
          imageAlt = _this$props.imageAlt,
          shouldHideImage = _this$props.shouldHideImage,
          placeholderBgColor = _this$props.placeholderBgColor,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          linkUrl = _this$props.linkUrl,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          flag = _this$props.flag,
          flagDark = _this$props.flagDark,
          shouldShowDivider = _this$props.shouldShowDivider,
          subContentOne = _this$props.subContentOne,
          subContentTwo = _this$props.subContentTwo,
          subContentThree = _this$props.subContentThree,
          subContentFour = _this$props.subContentFour,
          extraContent = _this$props.extraContent,
          primaryIconType = _this$props.primaryIconType,
          primaryIconStyle = _this$props.primaryIconStyle,
          primaryIconTitle = _this$props.primaryIconTitle,
          primaryIconOnClick = _this$props.primaryIconOnClick,
          primaryIconDropdown = _this$props.primaryIconDropdown,
          secondaryIconType = _this$props.secondaryIconType,
          secondaryIconStyle = _this$props.secondaryIconStyle,
          secondaryIconTitle = _this$props.secondaryIconTitle,
          secondaryIconOnClick = _this$props.secondaryIconOnClick,
          shouldShowIcons = _this$props.shouldShowIcons,
          containerSpacingClasses = _this$props.containerSpacingClasses,
          isConsumer = _this$props.isConsumer,
          isTargetBlank = _this$props.isTargetBlank,
          isNoFollow = _this$props.isNoFollow,
          focused = _this$props.focused,
          useSmallPadding = _this$props.useSmallPadding;
      var classes = classNames(containerSpacingClasses, 'eds-event-card-content', 'eds-event-card-content--list', "eds-event-card-content--".concat(style), "eds-event-card-content--".concat(imageStyle), {
        'eds-event-card-content--focused': focused,
        'eds-l-pad-vert-3': isConsumer
      });
      var imageContainer = null;

      if (!shouldHideImage) {
        imageContainer = React.createElement(ImageContainer, {
          onClick: onClick,
          linkUrl: linkUrl,
          imageUrl: imageUrl,
          isLazyImage: isLazyImage,
          imageAlt: imageAlt,
          imageStyle: imageStyle,
          flag: flag,
          flagDark: flagDark,
          style: style,
          placeholderBgColor: placeholderBgColor,
          isTargetBlank: isTargetBlank,
          isNoFollow: isNoFollow,
          isConsumer: isConsumer
        });
      }

      return React.createElement("article", {
        className: classes,
        onFocus: onFocus,
        onBlur: onBlur,
        role: "presentation"
      }, React.createElement(ExtraContentContainer, {
        imageStyle: imageStyle,
        style: style,
        extraContent: extraContent
      }), imageContainer, React.createElement(ListEventCardContentContainer, {
        extraContent: extraContent,
        title: title,
        subtitle: subtitle,
        onClick: onClick,
        linkUrl: linkUrl,
        linkAlt: imageAlt,
        isConsumer: isConsumer,
        isTargetBlank: isTargetBlank,
        isNoFollow: isNoFollow,
        style: style,
        shouldShowDivider: shouldShowDivider,
        subContentOne: subContentOne,
        subContentTwo: subContentTwo,
        subContentThree: subContentThree,
        subContentFour: subContentFour,
        primaryIconType: primaryIconType,
        primaryIconStyle: primaryIconStyle,
        primaryIconTitle: primaryIconTitle,
        primaryIconOnClick: primaryIconOnClick,
        primaryIconDropdown: primaryIconDropdown,
        secondaryIconType: secondaryIconType,
        secondaryIconStyle: secondaryIconStyle,
        secondaryIconTitle: secondaryIconTitle,
        secondaryIconOnClick: secondaryIconOnClick,
        shouldShowIcons: shouldShowIcons,
        useSmallPadding: useSmallPadding
      }));
    }
  }]);

  return ListEventCardContent;
}(Component);

_defineProperty(ListEventCardContent, "propTypes", _objectSpread({}, EVENT_CARD_PROPTYPES));

export { ListEventCardContent as default };